<template>
  <v-autocomplete
    :label="label"
    :items="entries"
    v-model="selectValue"
    :search-input.sync="searchQuery"
    :item-text="itemText"
    :item-value="itemValue"
    :placeholder="placeholder"
    :error-messages="errorMessages"
    :multiple="multiple"
    :disabled="disabled"
    :return-object="returnObject"
    :clearable="clearable"
    @click:clear="clickClearHandler($event)"
    @focus="getData"
  ></v-autocomplete>
</template>
<script>
export default {
  props: [
    "label",
    "placeholder",
    "value",
    "itemText",
    "itemValue",
    "errorMessages",
    "endpoint",
    "endless",
    "multiple",
    "disabled",
    "returnObject",
    "clearable",
    "searchField" // the query field for endpoint url
  ],
  data() {
    this.value && this.getData();
    return {
      selectValue: this.value,
      searchQuery: "",
      entries: []
    };
  },
  watch: {
    value(newVal) {
      this.selectValue = newVal;
    },
    selectValue(newVal) {
      this.$emit("input", newVal);
    },
    endpoint() {
      this.getData();
      this.$emit("click:clear", null);
      // this.$emit("input", null);
    }
  },
  methods: {
    async getData() {
      try {
        const { data } = await this.$axios.get(this.endpoint);
        this.entries = data;
      } catch (error) {
        console.error(error);
      }
    },
    clickClearHandler($event) {
      this.$emit("click:clear", $event);
    }
  }
};
</script>
